import React from 'react';
import { useState, useEffect } from 'react';
import Strapi from '../../services/strapi';
import { XGrid, RowsProp, ColDef, CellParams } from '@material-ui/x-grid';
import qs from 'qs';
import { TextField, Paper, Grid, makeStyles, Button } from '@material-ui/core';


const pageSize = 15;

interface AuthorListProps {
	action: (a: any, reload: () => void) => React.ReactElement,
	execpt_slug?: string[],
}

const useStyles = makeStyles(() => ({
	search: {
		margin: 20,
	},
	newAuthorButton: {
		margin: 20,
		display: 'flex',
		flex: 1
	},
	grid: {
		display: 'flex',
		flex: 1,
		marginTop: '1vh'
	},
	container: {
		display: 'flex',
		flexFlow: 'column',
		flex: 1
	}
}));

const AuthorList = (props: AuthorListProps) => {
	const [authors, setAuthors] = useState<any[]>([]);
	const [page, setPage] = useState<number>(1);
	const [loadling, setLoading] = useState<boolean>(false);
	const [rowCount, setRowCout] = useState<number>(0);
	const [rows, setRows] = useState<RowsProp>([]);
	const [searchFirstname, setSearchFirstname] = useState<string>("");
	const [searchLastname, setSearchLastname] = useState<string>("");
	const classes = useStyles();

	useEffect(() => {
		Strapi.get("authors/count").then((r) => {
			setRowCout(r);
		})
	}, [])

	const loadArticle = () => {
		const params: any = {
			_limit: pageSize,
			_start: (page - 1) * pageSize,
			_where : {
				slug_nin: props.execpt_slug ? props.execpt_slug : []
			}
		}
		params["firstname_contains"] = searchFirstname;
		params["lastname_contains"] = searchLastname;
		setLoading(true);
		Strapi.get("authors?" + qs.stringify(params), {
		}).then((r) => {
			setAuthors(r);
			setLoading(false);
		});
	}
	useEffect(() => {
		loadArticle();
	}, [page, searchLastname, searchFirstname]);

	useEffect(() => {
		const temp_rows: RowsProp = authors.map((e, i) => ({
			index: i,
			id: i,
			slug: e.slug,
			firstname: e.firstname,
			lastname: e.lastname,
			action: e.slug,
		}))
		setRows(temp_rows);
	}, [authors]);


	const columns: ColDef[] = [
		{ field: 'lastname', headerName: 'Nom', width: 300 },
		{ field: 'firstname', headerName: 'Prénom', width: 130 },
		{
			field: 'action', headerName: 'Action', width: 600, renderCell: (params: CellParams) => {
				return props.action(authors[params.data.index], loadArticle);
			}
		}
	];
	return (
		<div className={classes.container}>
			<Paper>
				<Grid container spacing={3}>
					<Grid item xs={3} className={classes.search}>
						<TextField fullWidth variant="outlined" label="Nom" onChange={(e) => {
							setSearchLastname(e.target.value);
						}}/>
					</Grid>
					<Grid item xs={3} className={classes.search}>
						<TextField fullWidth variant="outlined" label="Prénom" onChange={(e) => {
							setSearchFirstname(e.target.value);
						}}/>
					</Grid>
					<Grid item xs={6} className={classes.newAuthorButton} justify="flex-end">
						<Button color="primary" variant="outlined" href="/authors/create">Nouveau</Button>
					</Grid>
				</Grid>
			</Paper>
			<div className={classes.grid}>
				<XGrid
					pagination
					rows={rows}
					rowCount={rowCount}
					pageSize={pageSize}
					columns={columns}
					paginationMode="server"
					loading={loadling}
					onPageChange={(params) => {
						setPage(params.page)
					}}
				/>
			</div>
		</div>
	);
}

export default AuthorList;